import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f49190f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "session-trend-container f1 fv" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "f1 fh-c",
  style: {"height":"11.7%"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs16 color-06 bold" }, "会话走势图")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "f1",
  style: {"height":"88.3%"}
}, [
  /*#__PURE__*/_createElementVNode("div", { id: "session-trend" })
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}